import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { AnamnesiField } from "@/components/coaching/AnamnesiField";
import { sectionComplete } from "@/lib/coaching";

export const SectionStep = ({ s, form, set, onNext }) => {
  const ok = sectionComplete(form, s);
  return (
    <motion.div key={s.key} initial={{ opacity: 0, x: 30 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.4 }} data-testid={`anamnesi-section-${s.key}`}>
      <h2 className="font-display text-4xl font-900 uppercase leading-[0.95] md:text-6xl">{s.title}</h2>
      <p className="mt-3 text-sm text-[#a3b1aa] md:text-base">{s.text}</p>
      <div className="mt-8 space-y-6">
        {s.fields.map((f) => <AnamnesiField key={f.key} f={f} form={form} set={set} />)}
      </div>
      <button type="button" data-testid="anamnesi-next-btn" disabled={!ok} onClick={onNext}
        className="mt-10 flex w-full items-center justify-center gap-2 bg-[#98bfa2] px-7 py-4 font-display text-lg font-800 uppercase text-[#050807] transition-colors hover:bg-[#c4dcca] disabled:opacity-40 md:w-auto">
        Avanti <ArrowRight size={18} />
      </button>
      {!ok && <p className="mt-3 font-mono text-xs text-[#a3b1aa]">Rispondi a tutte le domande per continuare.</p>}
    </motion.div>
  );
};
